import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DataService } from "../data.service";
import { INavbarModule } from "../sidenavbar.module";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  isActive : boolean = false;
  isSearchActive: boolean = false;
  isSearchToolboxV2Active: boolean = false;
  isCompanyPagesActive: boolean = false;
  isPersonSearchActive: boolean = false;

  get navModules(): INavbarModule[] {
    return this.dataService.getNavModules || [];
  }
  
  constructor(public router : Router, private dataService: DataService) { }

  ngOnInit() {
    if (this.router.url.includes('candidate-list')){
      this.isActive = true
    }
    else if (this.router.url.includes('smartsearch')){
      this.isSearchActive = true
    }
    else if (this.router.url.includes('searchtoolbox-v2')){
      this.isSearchToolboxV2Active = true
    }
    else if(this.router.url.includes('company-directory')){
      this.isCompanyPagesActive = true;
    }
    else if(this.router.url.includes('person-search')){
      this.isPersonSearchActive = true;
    }
  }

  Route2ToolBox(toolboxVersion: string){
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      if (toolboxVersion === 'version1.0') {
        this.router.navigate(['/smartsearch']);
      } else if (toolboxVersion === 'version2.0') {
        this.router.navigate(['/searchtoolbox-v2']);
      }
    });
  }
}
